/* eslint @typescript-eslint/no-explicit-any: 0 */

import { useEffect } from 'react';

import Icon from '~/legacy/components/Icon';
import { useModal } from '~/legacy/hooks/useModal';
import type { MobileHeaderProps } from '~/legacy/types';
import { bem } from '~/legacy/utils';

import MainHeaderMobile from './MainHeaderMobile';

const MenuModal = ({
  menu,
  mobileMenuIsOpen,
  setMobileMenuIsOpen
}: MobileHeaderProps) => {
  const [isOpen, setOpen, setClosed]: [boolean, any, any] = useModal();

  useEffect(() => {
    mobileMenuIsOpen && setOpen && setOpen();
  }, [mobileMenuIsOpen, setOpen]);

  return (
    <div className="burger-menu">
      <div
        className="burger-menu__burger-holder"
        onClick={() => {
          setMobileMenuIsOpen(!mobileMenuIsOpen);
        }}
      >
        {!isOpen && (
          <Icon
            name="burger"
            className="burger-menu__burger-button"
            width="19"
            height="19"
            viewBox="0 0 30 30"
            fill="#ffffff"
          />
        )}
      </div>

      <div className={bem('burger-menu', [isOpen ? 'show' : 'hide'])}>
        <MainHeaderMobile
          menu={menu}
          setClosed={setClosed}
          setMobileMenuIsOpen={setMobileMenuIsOpen}
          mobileMenuIsOpen={mobileMenuIsOpen}
        />
      </div>
    </div>
  );
};

export default MenuModal;
